import React from 'react';

import './ArrowLeft.scss';

const ArrowLeft = ({extraClassName, color, onClick}) => {
  return (
    <svg
      className={extraClassName}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      onClick={onClick}
    >
      <path
        stroke={color || '#00F'}
        strokeWidth="2"
        d="M14.5 20.5 6 12l8.5-8.5"
      />
    </svg>
  );
};

export default ArrowLeft;
